import PaymentFormFields from './PaymentFormFields';
import React, { useEffect, useRef, useState } from 'react';
import { entityLabel } from '../../../../shared/components/EntityMultiSelect';

import { CircleDollarSign } from '../../../../shared/assets/AppIcons';
import { createImmediatePayment } from '../../services/accounting.service';
import { parseNumericDraft } from '../../../../shared/utils/numericInput';
import { CreateFormCancelButton, CreateFormDialog, CreateFormSubmitButton } from '../../../../shared/components/CreateFormDialog';

const initialForm = { amount: '', date: '', description: '', reason: '', clientId: '', clientIds: [], payerName: '', paymentMethod: 'immediato', notes: '' };

export default function CreateImmediatePaymentDialog({ open, onOpenChange, clients = [], onCreated }) {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);
  const mutex = useRef(false);
  const key = useRef(null);
  useEffect(() => {
    if (!open && !mutex.current) { setForm(initialForm); setError(''); key.current = null; }
  }, [open]);
  function update(field, value) { setForm(current => ({ ...current, [field]: value })); setError(''); }
  function selectClients(ids) {
    const selected = ids.map(id => clients.find(client => String(client.id) === String(id))).filter(Boolean);
    setForm(current => ({ ...current, clientIds: ids, clientId: ids[0] || '', payerName: selected.map(entityLabel).join(', ') }));
    setError('');
  }
  async function submit(event) {
    event.preventDefault();
    if (mutex.current) return;
    const amount = parseNumericDraft(form.amount, { min: 0.01 });
    if (!amount.ok) { setError('Inserisci un importo valido con massimo due decimali.'); return; }
    if (!form.description.trim() || !form.notes.trim() || !form.reason.trim() || !form.date) {
      setError('Compila titolo, descrizione, causale e data di pagamento.'); return;
    }
    if (!form.clientIds.length || !form.payerName) { setError('Seleziona almeno un cliente dal catalogo.'); return; }
    mutex.current = true; setSubmitting(true); setError('');
    if (!key.current) key.current = globalThis.crypto?.randomUUID?.() || `payment-${Date.now()}-${Math.random()}`;
    try {
      const result = await createImmediatePayment({ ...form, description: form.description.trim(), notes: form.notes.trim(), reason: form.reason.trim(),
        amount: amount.value, clientId: Number(form.clientId), clientIds: form.clientIds.map(Number) }, key.current);
      if (!result.ok) { setError(result.message); return; }
      await onCreated?.(result.data.payment);
      key.current = null; setForm(initialForm); setError(''); onOpenChange(false);
    } catch (cause) { setError(cause.message || 'Impossibile salvare l’incasso.'); }
    finally { mutex.current = false; setSubmitting(false); }
  }
  return <CreateFormDialog busy={isSubmitting} open={open} onOpenChange={onOpenChange}
    icon={CircleDollarSign} title="Nuovo Incasso" className="accounting-form-dialog"
    footer={<>
      <CreateFormCancelButton onClick={() => onOpenChange(false)} disabled={isSubmitting} />
      <CreateFormSubmitButton form="immediate-payment-form" saving={isSubmitting} disabled={!clients.length}>Salva incasso</CreateFormSubmitButton>
    </>}>
    <form id="immediate-payment-form" onSubmit={submit} className="party-form create-form-dialog__form">
      <PaymentFormFields form={form} update={update} selectClients={selectClients} clients={clients} isSubmitting={isSubmitting} />
      {!clients.length && <p role="status" className="party-form__help">Nessun cliente disponibile nel catalogo corrente.</p>}
      {error && <p role="alert" className="wt-inline-error">{error}</p>}
    </form>
  </CreateFormDialog>;
}
